import { useGet } from "../useGet";
import { UserInfo } from "../../types";

export const useGetUserInfo = () =>
  useGet<UserInfo>({
    url: `${process.env.REACT_APP_BACKEND_URL}/api/v2/userinfo`,
    serializer: async (response) => await response.json(),
  });
